import React, { useEffect } from 'react';
import { logout } from "../../Config/Reducers/AuthenticationReducer";
import { useSnackbar } from "notistack";
import { Navigate } from "react-router-dom";
import { useAppDispatch } from "../../Config/Hooks";
import { hideSubMenu } from "../../Config/Reducers/LayoutReducer";
import { useAuth } from 'react-oidc-context';

export const Logout = () => {
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const auth = useAuth();
    const [isLoggedOut, setIsLoggedOut] = React.useState(false);

    useEffect(() => {
        const handleLogout = async () => {
            try {
                // Limpar o Redux
                dispatch(logout());
                dispatch(hideSubMenu());

                // Fazer logout do OIDC
                await auth.signoutRedirect();
                
                // Mostrar mensagem de sucesso
                enqueueSnackbar("Logged out successfully!", { variant: 'success' });
                
                // Atualizar estado para redirecionar
                setIsLoggedOut(true);
            } catch (error) {
                console.error('Erro ao fazer logout:', error);
                enqueueSnackbar("Erro ao fazer logout", { variant: 'error' });
            }
        };

        handleLogout();
    }, []); // Execute apenas uma vez

    // Redirecionar apenas quando o logout estiver completo
    if (isLoggedOut) {
        return <Navigate to="/" replace />;
    }

    // Render null enquanto processa o logout
    return null;
};

export default Logout;